'use client'

export type IntegrationStatus = "live" | "dev" | "idea";

export type IntegrationCategory = "accounting" | "crm" | "payments" | "data" | "communications" | "roadmap";

export interface Integration {
  id: string;
  name: string;
  description: string;
  status: IntegrationStatus;
  category: IntegrationCategory;
}

export const INTEGRATIONS: Integration[] = [
  { id: "1c", name: "1С", description: "Каталог, остатки, клиенты, заказы и документы", status: "live", category: "accounting" },
  { id: "bitrix24", name: "Сторонние CRM", description: "Обмен клиентами и заявками с внешней CRM", status: "live", category: "crm" },
  { id: "payments", name: "Платежные агрегаторы", description: "Приём оплат и возврат статуса платежа", status: "live", category: "payments" },
  { id: "banks", name: "Банки", description: "Оплата заказа и подтверждение платежа", status: "live", category: "payments" },
  { id: "social", name: "Соц сети", description: "Приём обращений и публикаций из социальных сетей", status: "live", category: "communications" },
  { id: "messengers", name: "Мессенджеры", description: "Дополнительный канал коммуникации и уведомлений", status: "live", category: "communications" },
  { id: "marketplaces", name: "Маркетплейсы", description: "Обмен заказами и товарами с маркетплейсами", status: "live", category: "data" },
  { id: "email-smtp", name: "Email / SMTP", description: "Свой почтовый ящик для рассылок и писем", status: "live", category: "communications" },
  { id: "custom", name: "Другие внешние системы", description: "Оцениваем отдельно под конкретный процесс", status: "dev", category: "data" },
];

export const LIVE_INTEGRATIONS = INTEGRATIONS.filter((item) => item.status === "live");
export const DEVELOPING_INTEGRATIONS = INTEGRATIONS.filter((item) => item.status !== "live");
